import PropTypes from 'prop-types';

export default PropTypes.shape({
  width: PropTypes.number,
  height: PropTypes.number,
});
